export interface Holiday {
  date: string; // YYYY-MM-DD
  name: string;
  level: "national" | "state";
}

// Fonte: https://www.calendarr.com/brasil/feriados-minas-gerais/ (e feriados nacionais)
// Inclui feriados nacionais e estaduais de Minas Gerais para 2024, 2025 e 2026 como exemplo.
// É importante manter esta lista atualizada ou buscar uma fonte de dados mais dinâmica se necessário.

export const mockedHolidays: Record<number, Holiday[]> = {
  2024: [
    { date: "2024-01-01", name: "Confraternização Universal", level: "national" },
    { date: "2024-02-12", name: "Carnaval", level: "national" }, // Ponto Facultativo
    { date: "2024-02-13", name: "Carnaval", level: "national" },
    { date: "2024-02-14", name: "Quarta-feira de Cinzas", level: "national" }, // Ponto Facultativo até 14h
    { date: "2024-03-29", name: "Sexta-feira Santa", level: "national" },
    { date: "2024-04-21", name: "Tiradentes", level: "national" },
    { date: "2024-05-01", name: "Dia do Trabalho", level: "national" },
    { date: "2024-05-30", name: "Corpus Christi", level: "national" }, // Ponto Facultativo
    { date: "2024-08-15", name: "Assunção de Nossa Senhora (Belo Horizonte)", level: "state" }, // Feriado municipal em BH, mas considerado aqui como estadual para simplificação
    { date: "2024-09-07", name: "Independência do Brasil", level: "national" },
    { date: "2024-10-12", name: "Nossa Senhora Aparecida", level: "national" },
    { date: "2024-11-02", name: "Finados", level: "national" },
    { date: "2024-11-15", name: "Proclamação da República", level: "national" },
    { date: "2024-12-08", name: "Dia da Imaculada Conceição (Belo Horizonte)", level: "state" }, // Feriado municipal em BH, mas considerado aqui como estadual para simplificação
    { date: "2024-12-25", name: "Natal", level: "national" },
    // Adicionar Dia da Consciência Negra se for feriado estadual em MG ou nacional
    // { date: "2024-11-20", name: "Dia da Consciência Negra", level: "national" }, // Verificar legislação MG
  ],
  2025: [
    { date: "2025-01-01", name: "Confraternização Universal", level: "national" },
    { date: "2025-03-03", name: "Carnaval", level: "national" }, // Ponto Facultativo
    { date: "2025-03-04", name: "Carnaval", level: "national" },
    { date: "2025-03-05", name: "Quarta-feira de Cinzas", level: "national" }, // Ponto Facultativo até 14h
    { date: "2025-04-18", name: "Sexta-feira Santa", level: "national" },
    { date: "2025-04-21", name: "Tiradentes", level: "national" },
    { date: "2025-05-01", name: "Dia do Trabalho", level: "national" },
    { date: "2025-06-19", name: "Corpus Christi", level: "national" }, // Ponto Facultativo
    { date: "2025-08-15", name: "Assunção de Nossa Senhora (Belo Horizonte)", level: "state" },
    { date: "2025-09-07", name: "Independência do Brasil", level: "national" },
    { date: "2025-10-12", name: "Nossa Senhora Aparecida", level: "national" },
    { date: "2025-11-02", name: "Finados", level: "national" },
    { date: "2025-11-15", name: "Proclamação da República", level: "national" },
    { date: "2025-11-20", name: "Dia Nacional de Zumbi e da Consciência Negra", level: "national" },
    { date: "2025-12-08", name: "Dia da Imaculada Conceição (Belo Horizonte)", level: "state" },
    { date: "2025-12-25", name: "Natal", level: "national" },
  ],
  2026: [
    { date: "2026-01-01", name: "Confraternização Universal", level: "national" },
    { date: "2026-02-16", name: "Carnaval", level: "national" }, // Ponto Facultativo
    { date: "2026-02-17", name: "Carnaval", level: "national" },
    { date: "2026-02-18", name: "Quarta-feira de Cinzas", level: "national" }, // Ponto Facultativo até 14h
    { date: "2026-04-03", name: "Sexta-feira Santa", level: "national" },
    { date: "2026-04-21", name: "Tiradentes", level: "national" },
    { date: "2026-05-01", name: "Dia do Trabalho", level: "national" },
    { date: "2026-06-04", name: "Corpus Christi", level: "national" }, // Ponto Facultativo
    { date: "2026-08-15", name: "Assunção de Nossa Senhora (Belo Horizonte)", level: "state" },
    { date: "2026-09-07", name: "Independência do Brasil", level: "national" },
    { date: "2026-10-12", name: "Nossa Senhora Aparecida", level: "national" },
    { date: "2026-11-02", name: "Finados", level: "national" },
    { date: "2026-11-15", name: "Proclamação da República", level: "national" },
    { date: "2026-11-20", name: "Dia Nacional de Zumbi e da Consciência Negra", level: "national" },
    { date: "2026-12-08", name: "Dia da Imaculada Conceição (Belo Horizonte)", level: "state" },
    { date: "2026-12-25", name: "Natal", level: "national" },
  ],
};

export const getMockedHolidaysForYear = (year: number): Holiday[] => {
  return mockedHolidays[year] || [];
};

